import { useTranslation } from "react-i18next";
import { FolderOpen, Loader2 } from "lucide-react";
import { Button } from "components/common/Button";
import { FolderSuggestionErrorBanner } from "../FolderSuggestionErrorBanner";
import type { FolderSuggestionStatusProps } from "./types";

export const FolderSuggestionStatus = ({
  variant,
  planCount,
  onRetry,
  onClose,
}: FolderSuggestionStatusProps) => {
  const { t } = useTranslation();

  return (
    <>
      {variant === "loading" && (
        <div className="flex flex-col items-center justify-center gap-3 py-24 text-center text-sm text-gray-500">
          <Loader2 className="h-8 w-8 animate-spin text-blue-500" />
          {t("smartSurveyor.folders.suggestion.loading")}
          <span className="text-xs">
            {t("smartSurveyor.folders.suggestion.loadingDetail", {
              count: planCount,
            })}
          </span>
        </div>
      )}
      {(variant === "unavailable" || variant === "tooManyPlans") && (
        <>
          <FolderSuggestionErrorBanner
            error={variant}
            isLastResultKept={false}
            onRetry={onRetry}
          />
          <p className="py-16 text-center text-sm text-gray-500">
            {t("smartSurveyor.folders.suggestion.unchanged")}
          </p>
        </>
      )}
      {variant === "empty" && (
        <div className="flex flex-col items-center justify-center gap-2 py-20 text-center text-sm text-gray-500">
          <FolderOpen className="h-8 w-8 text-gray-500" strokeWidth={1.5} />
          <span className="font-medium text-gray-700">
            {t("smartSurveyor.folders.suggestion.empty")}
          </span>
          {t("smartSurveyor.folders.suggestion.unchanged")}
        </div>
      )}
      <div className="mt-4 flex justify-end border-t border-gray-200 pt-3">
        <Button onClick={onClose}>
          {t(
            variant === "loading"
              ? "smartSurveyor.common.cancel"
              : "smartSurveyor.common.close",
          )}
        </Button>
      </div>
    </>
  );
};
